export default "__VITE_ASSET__Co5XgjlI__"